export default {"src":"/_next/static/media/sap.1b1be5cd.svg","height":45,"width":91,"blurWidth":0,"blurHeight":0};